<script lang="ts">
    import { fade } from 'svelte/transition';

    import { trans } from '$assets/shop-translator.js';

    import { areAgesValid } from './utils';

    export let adultsAges: string[];
    export let childrenAges: string[];
    export let adultCount: number;
    export let childCount: number;
    export let showAdultAges: boolean = true;
    export let showChildAges: boolean = true;
    export let adultMinAge: number;
    export let childMinAge: number;
    export let childMaxAge: number | null;
    export let idPrefix: string = 'traveller';

    const preventNonNumericInput = (event: InputEvent): void => {
        if (event.data !== null && /\D/.test(event.data)) {
            event.preventDefault();
        }
    };

    const preventNonNumericKey = (event: KeyboardEvent): void => {
        if (['e', 'E', '+', '-', '.'].includes(event.key)) {
            event.preventDefault();
        }
    };
</script>

{#if (showAdultAges && adultCount > 0) || (showChildAges && childCount > 0)}
    <p class="text-xs text-content-quiet">
        {trans('tour.aside_panel.pax_popover.participants_details.text')}
    </p>
{/if}

{#if showAdultAges}
    {#each Array.from({ length: adultCount }, (_, index) => index) as index (index)}
        <div class="flex flex-col gap-xs" transition:fade>
            <label
                class="whitespace-nowrap text-sm"
                for="{idPrefix}-adult-age-{index}"
            >
                {trans('tour.aside_panel.pax_popover.adults.label')}
                {index + 1}
                <span class="text-xs text-content-quiet">
                    ({trans('tour.aside_panel.pax_popover.adult_min_age', {
                        '%minAge%': adultMinAge,
                    })})
                </span>
            </label>
            <input
                id="{idPrefix}-adult-age-{index}"
                name="adultAge[]"
                class="min-h-xl w-full px-m py-xs"
                type="number"
                step="1"
                inputmode="numeric"
                pattern="[0-9]*"
                placeholder={trans('tour.aside_panel.pax_popover.required_age')}
                required
                bind:value={adultsAges[index]}
                on:keydown={preventNonNumericKey}
                on:beforeinput={preventNonNumericInput}
            />
            {#if adultsAges[index] !== '' && Number(adultsAges[index]) < adultMinAge}
                <p class="text-sm text-status-negative" aria-live="polite">
                    {trans('tour.aside_panel.pax_popover.adult_age_invalid', {
                        '%minAge%': adultMinAge,
                    })}
                </p>
            {/if}
        </div>
    {/each}
{/if}

{#if showAdultAges && showChildAges && adultCount > 0 && childCount > 0}
    <hr />
{/if}

{#if showChildAges}
    {#each Array.from({ length: childCount }, (_, index) => index) as index (index)}
        <div class="flex flex-col gap-xs" transition:fade>
            <label
                class="whitespace-nowrap text-sm"
                for="{idPrefix}-child-age-{index}"
            >
                {trans('tour.aside_panel.pax_popover.child.label')}
                {index + 1}
            </label>
            <input
                id="{idPrefix}-child-age-{index}"
                name="childrenAge[]"
                class="min-h-xl w-full px-m py-xs"
                type="number"
                step="1"
                inputmode="numeric"
                pattern="[0-9]*"
                placeholder={trans('tour.aside_panel.pax_popover.required_age')}
                required
                bind:value={childrenAges[index]}
                on:keydown={preventNonNumericKey}
                on:beforeinput={preventNonNumericInput}
            />
            {#if childrenAges[index] !== '' && !areAgesValid([childrenAges[index]], 1, childMinAge, childMaxAge)}
                <p class="text-sm text-status-negative" aria-live="polite">
                    {trans('tour.aside_panel.pax_popover.child_age_invalid', {
                        '%minAge%': childMinAge,
                    })}
                </p>
            {/if}
        </div>
    {/each}
{/if}
